import { MainIcon } from "../../helper/MainIcon";

function Bismillah() {
    return (
        <>
            <div style={{ textAlign: "center" }}>
                <img style={{ height: "80px" }} src={MainIcon.Bismillah()}></img>
            </div>
        </>
    )
}

export default Bismillah;